export default {
  not_set_up: {
    title: 'Reserveringen zijn nog niet ingesteld voor deze locatie',
    description:
      'Een locatie krijgt reserveringen zodra deze is gekoppeld aan de Google-vermelding en een eigenaar heeft. Als het restaurant nog geen eigenaar heeft, voeg er dan een toe onder Team. Tot die tijd zijn er hier geen reserveringsopeningstijden om te bewerken en worden wijzigingen in de openingstijden van de Online Shop niet gekopieerd naar Reserveringen.',
  },
  company_not_loaded: {
    title: 'Reserveringsinstellingen konden niet worden geladen',
    description:
      'De reserveringsinstellingen van deze locatie konden niet worden geladen, daarom kunnen de openingstijden voor reserveringen momenteel niet worden bewerkt. Probeer het opnieuw.',
    retry: 'Opnieuw proberen',
  },
};
